import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

class InviteCard extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    isReceivedInvite: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    acceptCard: PropTypes.func.isRequired,
    ignoreCard: PropTypes.func.isRequired,
    cancelCard: PropTypes.func.isRequired,
    resendCard: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  onAcceptClick = () => {
    const { acceptCard, id } = this.props
    acceptCard(id)
  }

  onIgnoreClick = () => {
    const { ignoreCard, id } = this.props
    ignoreCard(id)
  }

  onResendClick = () => {
    const { resendCard, id } = this.props
    resendCard(id)
  }

  onCancelClick = () => {
    const { cancelCard, id } = this.props
    cancelCard(id)
  }

  render() {
    const { name, email, isReceivedInvite } = this.props
    const buttons = isReceivedInvite
      ? [
          { label: 'ACCEPT', onClick: this.onAcceptClick },
          { label: 'IGNORE', onClick: this.onIgnoreClick },
        ]
      : [
          { label: 'RESEND', onClick: this.onResendClick },
          { label: 'CANCEL', onClick: this.onCancelClick },
        ]

    return (
      <div className={styles.cardContainer}>
        <div className={styles.statusIconContainer}>
          <i className="fa fa-handshake-o" style={{ fontSize: 25, color: 'white' }} />
        </div>
        <div className={styles.nameEmailContainer}>
          <div style={{ fontSize: 18, color: 'white', marginBottom: 5, flex: 0.4 }}>{name}</div>
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', flex: 0.6 }}>{email}</div>
        </div>
        <div className={styles.buttonContainer}>
          {buttons.map(b => (
            <button key={b.label} className={styles.button} onClick={b.onClick}>
              {b.label}
            </button>
          ))}
        </div>
      </div>
    )
  }
}

export default InviteCard



// WEBPACK FOOTER //
// ./src/views/collaborate/collaborator-panel/invite-card/index.js